import { testimonials } from "@/mocks/chigua";

export default function Testimonials() {
  return (
    <section id="reviews" className="py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <p className="mb-2 text-xs font-medium tracking-widest text-primary-500">VOICE OF THE CROWD</p>
          <h2 className="font-display text-3xl text-foreground-950 md:text-4xl">
            群众<span className="text-primary-500">口碑</span>
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            数十万群众在这里打卡蹲点，看看大家是怎么评价吃瓜52的。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="flex flex-col rounded-3xl border border-background-200 bg-background-100 p-6"
            >
              <div className="flex gap-1 text-secondary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <span className="mt-3 inline-flex w-fit rounded-full bg-primary-50 px-2.5 py-1 text-xs font-medium text-primary-600">
                {t.tag}
              </span>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <img src={t.avatar} alt={`${t.name} 的头像`} className="h-11 w-11 rounded-full object-cover" />
                <div>
                  <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}